import './style.scss'

import { useParams, withRouter } from 'react-router-dom'

import React from 'react'
import classNames from 'classnames'
import { dateFormat } from '../../../../helpers/date'

const News = ({ id, title, content, coverImage, tags, created, history }) => {
  const { siteId } = useParams()

  return (
    <div
      className='news'
      onClick={() => history.push('/soccer/sites/' + siteId + '/news/' + id)}
    >
      <div className='-aspect'>
        <div className='-image'>
          <img
            src={process.env.REACT_APP_IMAGE_BASE_URL + '/news/' + coverImage}
            alt=''
          />
        </div>
      </div>
      <div className='-tags'>
        {tags.split(',').map((tag, index) => (
          <div key={index}>{tag}</div>
        ))}
      </div>
      <div className='-title'>{title}</div>
      <div className='-date'>{dateFormat(created, 'dd "de" mmmm')}</div>
      <div className={classNames('-description-wrapper', '-preview')}>
        <div
          className='-description'
          dangerouslySetInnerHTML={{ __html: content }}
        />
        <div className='-see-more-overlay'></div>
      </div>
    </div>
  )
}

export default withRouter(News)
